import { API_PRECOG_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const GET_USED_GOODS_START = "GET_USED_GOODS_START";
export const GET_USED_GOODS_SUCCESS = "GET_USED_GOODS_SUCCESS";
export const GET_USED_GOODS_ERROR = "GET_USED_GOODS_ERROR";
export const CLEAR_USED_GOODS = "CLEAR_USED_GOODS";
export const CLEAR_USED_GOODS_DETAIL = "CLEAR_USED_GOODS_DETAIL";
export const GET_USED_GOODS_DETAIL_START = "GET_USED_GOODS_DETAIL_START";
export const GET_USED_GOODS_DETAIL_SUCCESS = "GET_USED_GOODS_DETAIL_SUCCESS";
export const GET_USED_GOODS_DETAIL_ERROR = "GET_USED_GOODS_DETAIL_ERROR";
export const UPDATE_USED_GOODS_DETAIL_START = "UPDATE_USED_GOODS_DETAIL_START";
export const UPDATE_USED_GOODS_DETAIL_SUCCESS = "UPDATE_USED_GOODS_DETAIL_SUCCESS";
export const UPDATE_USED_GOODS_DETAIL_ERROR = "UPDATE_USED_GOODS_DETAIL_ERROR";

export function getUsedGoods(draftId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    const managerCF = getState().main.accountantSelected;
    const itemCF = getState().main.companySelected;

    dispatch({
      type: GET_USED_GOODS_START
    });

    return new Promise((resolve, reject) => {
      
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/usedGoods?managerId=${managerId}&itemId=${itemId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(
            auth.loginAuth.securityToken, null, managerCF, itemCF
          )
        }
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: GET_USED_GOODS_SUCCESS,
              payload: result.data
            });
            resolve(result.data);
          } else {
            dispatch({
              type: GET_USED_GOODS_ERROR,
              payload: result.data
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: GET_USED_GOODS_ERROR,
            payload: response
          });
          reject();
        });     
    });
  };
}

export function getUsedGoodsDetail(draftId, goodsId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    const managerCF = getState().main.accountantSelected;
    const itemCF = getState().main.companySelected;

    dispatch({
      type: GET_USED_GOODS_DETAIL_START
    });

    return new Promise((resolve, reject) => {
      
      let request = {
        method: "GET",        
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/usedGoods/${goodsId}?managerId=${managerId}&itemId=${itemId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(
            auth.loginAuth.securityToken, null, managerCF, itemCF
          )
        }
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: GET_USED_GOODS_DETAIL_SUCCESS,
              payload: result.data
            });
            resolve(result.data);
          } else {
            reject();
          }
        })
        .catch((response) => {
          reject();
          dispatch({
            type: GET_USED_GOODS_DETAIL_ERROR,
            payload: response
          });
          
        });      
    });
  };
}

export function updateUsedGoodsDetail(
  draftId, goodsId, updatedObj
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    const managerCF = getState().main.accountantSelected;
    const itemCF = getState().main.companySelected;

    dispatch({
      type: UPDATE_USED_GOODS_DETAIL_START
    });

    return new Promise((resolve, reject) => {
      
      let request = {
        method: "PATCH",        
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/usedGoods/${goodsId}?managerId=${managerId}&itemId=${itemId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(
            auth.loginAuth.securityToken, null, managerCF, itemCF
          )
        },
        data: updatedObj
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: UPDATE_USED_GOODS_DETAIL_SUCCESS,
              payload: result.data
            });
            resolve(result.data);
          } else {
            reject();
          }
        })
        .catch((response) => {
          reject();
          dispatch({
            type: UPDATE_USED_GOODS_DETAIL_ERROR,
            payload: response
          });
          
        });      
    });
  };
}

export function clearUsedGoods() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_USED_GOODS
    });
  };
}

export function clearUsedGoodsDetail() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_USED_GOODS_DETAIL
    });
  };
}

export function getFixedUsedGoodsList(businessId=null, filters = null) {
  return (dispatch, getState) => {
    
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;

    return new Promise((resolve, reject) => {
      
      let params = "";
      for (let f in filters) {
        if (filters[f]) params += `&${f}=${filters[f]}`;
      }

      let request = {
        method: "GET",        
        url: `${API_PRECOG_URL_V1}/usedGoods?${businessId ? "businessId="+ businessId + "&" : ""}managerId=${managerId}&itemId=${itemId}${params}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };
  
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {          
          resolve(result.data);
        })
        .catch((err) => {        
          reject(err);
        });
        
    });
  };
}
